import { render, staticRenderFns } from "./ModalMostrarSolicitudInscripcion.vue?vue&type=template&id=6fa2c222"
import script from "./ModalMostrarSolicitudInscripcion.vue?vue&type=script&lang=js"
export * from "./ModalMostrarSolicitudInscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports